import axios from 'axios'
import { attachNetworkQualityInterceptor } from '@/utils/networkQualityMonitor'


const baseUrl = `${process.env.VUE_APP_PROTOCOL}://${window.location.hostname}/authentication/api/v1`;

const authLanguageClient = axios.create({
    baseURL: baseUrl
})

attachNetworkQualityInterceptor(authLanguageClient)

export default authLanguageClient